module.exports = __webpack_public_path__ + "dfff0b4a25dc256a18eabc0c625bcf22.pdf";